import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner, Input } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseTableColumnNames, fetchAllCourses, createCourses, updateCourses, deleteCourses, activateDeactivateCourses, 
  fetchAllReferralReward, getDays, updateUserPreference, uploadCourseIcon, 
  fetchTranslation} from "../../../slices/thunks";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
// import AddModal from "../../../Components/Common/Modal/AddModal"; // Replaced by CommonAddModal
import AddCourseForm from "../../../Components/Common/AddCourseForm/AddCourseForm";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";
import usePermissions from "../../../Components/Hooks/usePermissions";
import { ErrorMessage } from "formik";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";

const labels = [
  {
    id: 1,
    labelName: "CourseNameEnglish",
    fieldName: "text-box-translate",
    name: "CourseNameEn",
    value: "CourseNameEn",
    required: true,
    errorMessage:"Course Name English Is Require",
    translateTo: "CourseNameAr",
    minLength:3,
    maxLength: 70,
  },
  {
    id: 2,
    labelName: "CourseNameArabic",
    fieldName: "text-box",
    name: "CourseNameAr",
    value: "CourseNameAr",
    required: true,
    errorMessage:"Course Name Arabic Is Require",
    minLength:3,
    maxLength: 70,
  },
  {
    id: 3,
    labelName: "CourseDescriptionEnglish ",
    fieldName: "textarea-translate",
    name: "CourseDescriptionEn",
    value: "CourseDescriptionEn",
    required: true,
    errorMessage:"Course Description English Is Require",
    translateTo: "CourseDescriptionAr",
  },
  {
    id: 4,
    labelName: "CourseDescriptionArabic ",
    fieldName: "textarea-box",
    name: "CourseDescriptionAr",
    value: "CourseDescriptionAr",
    required: true,
    errorMessage:"Course Description Arabic Is Require",
  },
  {
    id: 5,
    labelName: "StartDate",
    fieldName: "date",
    name: "StartDate",
    value: "StartDate",
    required: true,
    errorMessage:"Start Date Is Require",
    minToday: true,
    disabled: (mode) => mode === 'isEdit', 
  },
  {
    id: 6,
    labelName: "SelectDays",
    fieldName: "day-multiselect-dropdown",
    name: "Days",
    value: "Days",
    required: true,
    errorMessage:"Days are Required",
    disabled: (mode) => mode === 'isEdit', 
  },
  {
    id: 7,
    labelName: "Price",
    fieldName: "number-box",
    name: "Price",
    value: "Price",
    required: true,
    errorMessage:"Price Is Require"
  },
  {
    id: 9, // Make sure this ID is unique
    labelName: "Credits",
    fieldName: "number-box",
    name: "Credits",
    value: "Credits",
    required: true, 
    errorMessage:"Credits Is Require"
  },
  {
    id: 8,
    labelName: "CourseIcon",
    fieldName: "file",
    name: "CourseIcon",
    value: "CourseIcon",
    required: true, // Make false if icon is optional for new courses
    errorMessage:"Course Icon Is Require",
    accept: "image/*", // Specify accepted file types
  },
  {
    id: 10,
    labelName: "Referral",
    fieldName: "referral-dropdown",
    name: "CategoryID",
    value: "CategoryID",
    required: true,
    errorMessage:"Referral Is Require",
  },
];

const actionConfig = {
  edit: {
    icon: "ri-edit-2-line",
    tooltip: "Edit",
  },
  delete: {
    icon: "ri-delete-bin-2-line",
    tooltip: "Delete",
  },
};


function Courses () {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const {user} = getAuthUser();
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [lastTranslatedField, setLastTranslatedField] = useState(null);

  // const [isFormValid, setIsFormValid] = useState(false);

  const { Courses, tableColumnNames, loading, loadings, translationLoading } = useSelector((state) => ({
    Courses: state.Courses.courses,  
    tableColumnNames: state.Courses.tableColumnNames,
    loading: state.Courses.loading,
    loadings: state.Courses.loadings,
    Translations: state.Module.translations,
    translationLoading: state.Module.translationLoading, 
  }));

  // Compute permission
  const permission = (() => {
    return usePermissions(8, 7);
  })();
  

  const handleButtonClick = (module) => {
    navigate(`/manage-courses/${module.ID}/modules`)
  }

  const onAddClickHandler = (value) => {
    setShow(true);
    setIsAddOrEdit(value);
    setSelectedRow({}); 
  };

  const onEditClickHandler = (course, value) => {
    setSelectedRow(course);
    setIsAddOrEdit(value);
    setShow(true); 
  };

  const onTranslateClickHandler = (targetField, textToTranslate, formikSetFieldValue, sourceFieldName) => {
    if (!textToTranslate || textToTranslate.trim() === "") {
      toast.error(t("EnterTextToTranslate"));
      return;
    }
    setLastTranslatedField(sourceFieldName); 

    dispatch(fetchTranslation({ LangText: textToTranslate }))
      .unwrap() 
      .then(translatedText => {
        formikSetFieldValue(targetField, translatedText);
      })
      .catch(error => {
        console.error("Translation error:", error);
        toast.error(t("TranslationFailed"));
      })
      .finally(() => {
        setLastTranslatedField(null); 
      });
  };

  
  
  const onActiveOrDeactiveChange = (course, e) => {
    dispatch(activateDeactivateCourses({ ID: course.ID, IsActive: course.IsActive }));
  };
  
  const onSubmitHandler = async (values, { resetForm, setSubmitting }) => {
    setSubmitting(true);
     try {
      let courseIconUrl = values.CourseIcon;
      
      const courseObj = {
        CourseNameEn: values.CourseNameEn.trim(),
        CourseNameAr: values.CourseNameAr.trim(),
        CourseDescriptionEn: values.CourseDescriptionEn.trim(),
        CourseDescriptionAr: values.CourseDescriptionAr.trim(),
        NoOfModules: isAddOrEdit === "isEdit" ? selectedRow.NoOfModules : 0, 
        CourseIcon: courseIconUrl,
        CategoryID: values.CategoryID,
        Days: values.Days || [], 
        StartDate: values.StartDate,
        Duration: values.Duration,
        Price: values.Price,
        Discount: values.Discount || 0, 
        LimitedSeat: values.LimitedSeat || false, 
        Credits: values.Credits,
      };

      if (isAddOrEdit === "isEdit" && selectedRow?.ID) {
        courseObj.ID = selectedRow.ID;
      }

      setShow(false);
      if (isAddOrEdit === "isAdd") {
        await dispatch(createCourses(courseObj))
      } else {
        await dispatch(updateCourses(courseObj))
      }
      
      resetForm();
    } catch (error) {
      console.error("Error submitting course:", error);
      toast.error(t("SubmissionFailed") + (error.message ? `: ${error.message}` : ''));
    } finally {
      setSubmitting(false);
    }
  };

  const saveUserPreferences = async () => {
    const preferencesPayload = {
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };

    setModalOpen(false);
    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(
        fetchCourseTableColumnNames({
          module: "COURSES"
        })
      );

    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const confirmDelete = () => {
    dispatch(deleteCourses({ Ids: selectedIds, UserId: user.UserId }))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };

  useEffect(() => {
    dispatch(fetchCourseTableColumnNames({ module: "COURSES" }))
    dispatch(fetchAllCourses());
    dispatch(fetchAllReferralReward());
    dispatch(getDays());

  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("Courses")} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardHeader>
                <Row className="g-4">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                      {permission.CanAdd && (
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => onAddClickHandler("isAdd")}
                          id="create-btn"
                          disabled={loading}
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      )}
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                        disabled={loading}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row>
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
            
                {loading || loadings ? (
                  <div className="d-flex justify-content-center align-items-center">
                  <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                    Loading...
                  </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                      <CommonDataTable
                        data={Courses}
                        tableColumnNames={tableColumnNames}
                        searchTerm={searchTerm}
                        onEditClickHandler={onEditClickHandler}
                        onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                        handleButtonClick={handleButtonClick}
                        setDeleteModal={setDeleteModal}
                        setSelectedIds={setSelectedIds}
                        keyField="ID" // Add this prop, adjust "ID" if your key is different, or prop name if it's not keyField
                        actionConfig={actionConfig}
                        permission={permission}
                      />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* Modal  */}
      <CommonAddModal
        show={show}
        setShow={setShow}
        onSubmitHandler={onSubmitHandler}
        labels={labels}
        isAddOrEdit={isAddOrEdit}
        selectedItemData={selectedRow} 
        FormBody={AddCourseForm}
        FormBodyProps={{ 
          onTranslateClickHandler, 
          translationLoading,
          lastTranslatedField: lastTranslatedField,
        }} 
        title={isAddOrEdit === "isAdd" ? t("AddNewCourse") : t("EditCourse")}
        size="xl"
      />
        
      

      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={saveUserPreferences}
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={`you want to delete this course? This will also permanently remove all associated modules and their sessions.`}
      />
    </div>
  );
}

export default Courses;